export enum DuluxLocationPagesWorkspaceCapabilityUdoTemplateKey {
    locationPage = "0f769a7b-8800-47fa-a859-dbc64854cdb7",
}
